export const environment = {
    production: false,
    apiUrl: 'https://lumat.com.py:8080/webavancemos/api/v1/sp',
    viewUrl: 'https://lumat.com.py:8080/webavancemos',
    presetToken: 'KIlTS8g1YkCCARv0EoRHCDMSFTkq8VbkRMVfUbiACJ8uA70fdqfCIXmfJ9osdWpKfmwUWD2WAgkoa'
};
